module.exports = __webpack_public_path__ + "img/clipboard_disable.0aafd0c8.svg";